import { render, staticRenderFns } from "./PesquisaPage.vue?vue&type=template&id=1a18566c&scoped=true"
import script from "./PesquisaPage.vue?vue&type=script&lang=js"
export * from "./PesquisaPage.vue?vue&type=script&lang=js"
import style0 from "./PesquisaPage.vue?vue&type=style&index=0&id=1a18566c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18566c",
  null
  
)

export default component.exports